import { Injectable } from '@angular/core';
import moment from 'moment';
import { Constant } from '../constant';
import { saveAs } from 'file-saver'
import { LocalStorageService } from '../LocalStorageService';
const { downloadFile } =require('src/myfunc.js')

@Injectable({
  providedIn: 'root'
})
export class SaveAsExcelfileService {
  constant: Constant = new Constant();
  constructor(public persistenceService: LocalStorageService) { }

  saveAsCSVFile(data: any, fileName: string) {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    console.log("Data="+data)
    console.log("Header="+header);
    //let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    let csv=data;
    console.log("CSV="+csv);
    csv.unshift(data.join(','));
    //let csvArray = csv.join('\t');

    var blob = new Blob([csv], {type: 'text/csv' })
    let formattedDate = "AAAA-"+moment(new Date().getTime()).format(this.constant.dateTimeFormatForDBServer);
    if (this.persistenceService.get("OS") == "Android") {
      downloadFile(new Uint8Array(blob as unknown as ArrayBuffer), fileName, "csv");
    } else {
      saveAs(
        blob,
        fileName + "_format_" + formattedDate + ".csv"
      );
    }
    
}

  saveAsExcelFile(buffer: any, fileName: string): void {

    if (this.persistenceService.get("OS") == "Android") {
      downloadFile(new Uint8Array(buffer as ArrayBuffer), fileName, "xls");
    } else {

      import("file-saver").then(FileSaver => {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE
        });

        let formattedDate = moment(new Date().getTime()).format(this.constant.dateTimeFormatForDBServer);
        saveAs(
          data,
          fileName + "_export_" + formattedDate + EXCEL_EXTENSION
        );
      });
      // window.addEventListener("beforeunload", function (e) {
      //   var confirmationMessage = "\o/";
      //   console.log("cond");
      //   e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
      //   return confirmationMessage;              // Gecko, WebKit, Chrome <34
      // });
    }
  }

  saveAsCsvFile(buffer: any, fileName: string): void {
    if (this.persistenceService.get("OS") == "Android") {
      downloadFile(new Uint8Array(buffer as ArrayBuffer), fileName, "csv");
    } else {
    import("file-saver").then(FileSaver => {
      let CSV_TYPE =
        "text/csv";
      let CSV_EXTENSION = ".csv";
      const data: Blob = new Blob([buffer], {
        type: CSV_TYPE
      });
      let formattedDate = moment(new Date().getTime()).format(this.constant.dateTimeFormatForDBServer);
      saveAs(
        data,
        fileName + "_export_" + formattedDate + CSV_EXTENSION
      );
    });
  }
}
}
